module.exports = __webpack_public_path__ + "img/1531632141.c31ce76e.jpg";